<div class="wb-holder">
  <div class="wb-item-header" [ngStyle]="{ 'background-color': item.headerColor }">
    <div class="wb-flex-row">
      <mat-icon class="wb-item-icon">{{ item.icon }}</mat-icon>
      <span class="wb-item-title">{{ item.title }}</span>

      <div class="wb-flex-item" style="white-space: nowrap; margin-left: 10px" *ngIf="item.type === 'queueAgents'">
        Work Hours: {{ queueAgentsData.workHoursStart }} - {{ queueAgentsData.workHoursEnd }}
      </div>

    </div>
    <div class="wb-flex-row">
      <div class="wb-flex-item" style="font-size: 16px; font-weight: bold; white-space: nowrap" *ngIf="item.type === 'queueAgents'">
        {{ queueAgentsData.loggedInAgents }} / {{ queueAgentsData.totalAgents }}
      </div>
      <button type="button" mat-icon-button class="wb-flex-item" style="padding: 0; margin-left: 5px; height: auto; width: auto"
              *ngIf="item.type === 'queueAgents'" matTooltip="Only active agents"
              (click)="onToggleAgentsFilterChange($event, queueAgentsData)">
        <mat-icon *ngIf="!queueAgentsData.filterActive">toggle_off</mat-icon>
        <mat-icon *ngIf="queueAgentsData.filterActive" [ngStyle]="{'color':'rgb(57, 203, 118)'}">toggle_on</mat-icon>
      </button>
      <button type="button" mat-icon-button class="wb-flex-item" style="padding: 0; margin-left: 5px; height: auto; width: auto"
              *ngIf="isEditing" matTooltip="Remove widget"
              (click)="removeWidgetEvent.emit(item)">
        <mat-icon [ngStyle]="{'font-size': '20px'}"
                  color="warn">delete</mat-icon>
      </button>
    </div>
  </div>
  <div class="wb-item-body">
    <div class="wb-type-counter" *ngIf="item.type === 'counter'">
      <span class="wb-type-counter-value">{{ counterData?.value }}</span>
    </div>
    <div class="wb-type-counter-percentage" *ngIf="item.type === 'counterPercent'">
      {{ counterPercentData?.count }} / {{ counterPercentData?.percent }}%
    </div>
    <div class="wb-type-duration" *ngIf="item.type === 'duration'">
      <span class="wb-type-duration-value">{{ durationData?.duration | duration:true }}</span>
    </div>
    <app-pbx-wb-queue-agents-widget *ngIf="item.type === 'queueAgents'"
                                    [itemData]="queueAgentsData" [filterActive]="queueAgentsData.filterActive">
    </app-pbx-wb-queue-agents-widget>
    <app-pbx-wb-live-calls-widget *ngIf="item.type === 'liveCalls'"
                                  [itemData]="liveCallsData">
    </app-pbx-wb-live-calls-widget>
  </div>
</div>
